import { ElementTypeEnum } from "../../elementTypeMappings";
import BimProduct from "../BimProduct";
import Product from "../Product";
import BimCovering from "./BimCovering";
import BimSpace from "./BimSpace";

const createBimProduct = (product: Product, parent?: BimProduct | undefined): BimProduct => {

    let bimProduct : BimProduct;

    switch(product.productData.productType) {
        case(ElementTypeEnum.Space):
            bimProduct = new BimSpace(product, parent);
            break;
        case(ElementTypeEnum.Covering):
            bimProduct = new BimCovering(product, parent);
            break;
        default:
            bimProduct = new BimProduct(product, parent);
            break;
    }   

    // Create children 
    product.children.forEach(childProduct => {
        const childBimProduct = createBimProduct(childProduct, bimProduct);
        bimProduct.addChild(childBimProduct);
    });
    
    return bimProduct;
};

export default createBimProduct;